import { ROUTES } from "./";

export const MANAGE_CENSUS_ROUTES = {
  EMPLOYEE_INFORMATION: `${ROUTES.MANAGE_CENSUS}/employee-information`,
  EMPLOYEE_MANAGE_PLANS: `${ROUTES.MANAGE_CENSUS}/employee-plans`,
  EMPLOYEE_MANAGE_TRANSACTIONS: `${ROUTES.MANAGE_CENSUS}/employee-transactions`,
  EMPLOYEE_MANAGE_PLAN_MODULES: `${ROUTES.MANAGE_CENSUS}/employee-manage-plans`,
  EMPLOYEE_HISTORY: `${ROUTES.MANAGE_CENSUS}/employee-history`,
  ROLLOVER_REQUEST: `${ROUTES.MANAGE_CENSUS}/rollover-request`,
  ROLLOVER_SUMMARY: `${ROUTES.MANAGE_CENSUS}/rollover-summary`,
  BENEFICIARY_DETAILS: `${ROUTES.MANAGE_CENSUS}/benificiary-details`,
  INVESTMENT_PERFORMANCE: `${ROUTES.MANAGE_CENSUS}/investment-performance`,
  MANUAL_ENROLLMENT: `${ROUTES.MANAGE_CENSUS}/manual-enrollment`,
  ENROLLMENT_REPORT: `${ROUTES.MANAGE_CENSUS}/enrollment-Report`,
  ADD_BENEFICIARY: `${ROUTES.MANAGE_CENSUS}/add-beneficiary`,
  ACCOUNT_BALANCE: `${ROUTES.MANAGE_CENSUS}/account-balance`,
};

export const MANAGE_CENSUS_MENU = [
  {
    id: "employeeInformation",
    label: "Employee Information",
    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_INFORMATION,
    contentHeader: "Add Employee",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "employeeTransactions",
    label: "Transactions",
    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
    contentHeader: "Transactions",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST,
      MANAGE_CENSUS_ROUTES.ROLLOVER_SUMMARY,
    ],
  },
  {
    id: "employeeManagePlans",
    label: "Plans",
    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLANS,
    contentHeader: "Plans",
    breadCrumbs: [],
    childRoutes: [MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLAN_MODULES],
  },
  {
    id: "manageCensusHistory",
    label: "History",
    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_HISTORY,
    contentHeader: "History",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "beneficiaryDetails",
    label: "Beneficiary Details",
    path: MANAGE_CENSUS_ROUTES.BENEFICIARY_DETAILS,
    contentHeader: "Beneficiary Details",
    breadCrumbs: [],
    childRoutes: [MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY],
  },
  {
    id: "personalInvestmentPerformance",
    label: "Personal Investment Performance",
    path: MANAGE_CENSUS_ROUTES.INVESTMENT_PERFORMANCE,
    contentHeader: "Personal Investment Performance",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "accountBalance",
    label: "Account Balance",
    path: MANAGE_CENSUS_ROUTES.ACCOUNT_BALANCE,
    contentHeader: "Account Balance",
    breadCrumbs: [],
    childRoutes: [],
  },
];

export const ALL_MANAGE_CENSUS_ROUTES = [
  ...MANAGE_CENSUS_MENU,
  {
    id: "employeeInformation",
    contentHeader: "Manage Employees",
    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_INFORMATION,
    breadCrumbs: [
      {
        label: "Manage Employees",
        link: MANAGE_CENSUS_ROUTES.EMPLOYEE_INFORMATION,
      },
    ],
  },
  {
    id: "employeeManagePlans",
    contentHeader: "Manual Enrollment",
    path: MANAGE_CENSUS_ROUTES.MANUAL_ENROLLMENT,
    breadCrumbs: [
      {
        label: "Manual Enrollment",
        link: MANAGE_CENSUS_ROUTES.MANUAL_ENROLLMENT,
      },
    ],
  },
  {
    id: "employeeManagePlans",
    contentHeader: "Enrollment Report",
    path: MANAGE_CENSUS_ROUTES.ENROLLMENT_REPORT,
    breadCrumbs: [
      {
        label: "Enrollment Report",
        link: MANAGE_CENSUS_ROUTES.ENROLLMENT_REPORT,
      },
    ],
  },
  {
    id: "employeeManagePlans",
    contentHeader: "Plans",
    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_PLAN_MODULES,
    breadCrumbs: [],
  },
  {
    id: "beneficiaryInformation",
    contentHeader: "Beneficiary Information",
    path: MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY,
    breadCrumbs: [],
  },
];

export const manageCensusFormNames = {
  CENSUS_FILTER: "census filter",
  PERSONAL_INFORMATION: "personal information",
  ADD_COMPENSATIONS: "add_compensations",
  CONTRIBUTIONS_FILTER: "contributions_filter",
  ADD_CONTRIBUTIONS: "add_contributions",
  CENSUS_HISTORY: "census_history",
  HOURS: "hours",
  MANUAL_ENROLLMENT: "manual_enrollment",
  BENEFICIARY_DETAILS: "beneficiary-details",
  CENSUS_VESTING: "census_vesting",
  ROLLOVER_REQUEST: "rollover_request",
};

export const censusFormFields = {
  [manageCensusFormNames.CENSUS_FILTER]: {
    companyId: "companyId",
    companyName: "companyName",
    planSearchOption: "planSearchOption",
    planId: "planId",
    planName: "planName",
    rKPlanNumber: "rKPlanNumber",
    employmentStatusId: "employmentStatusId",
    employmentStatusName: "employmentStatusName",
    searchBySSNEmpIdName: "searchBySSNEmpIdName",
    startDate: "startDate",
    endDate: "endDate",
    companyNameAutoEnrollment: "companyNameAutoEnrollment",
    planNameAutoEnrollment: "planNameAutoEnrollment",
    planIdAutoEnrollment: "planIdAutoEnrollment",
    companyIdAutoEnrollment: "companyIdAutoEnrollment",
  },
  [manageCensusFormNames.PERSONAL_INFORMATION]: {
    firstName: "firstName",
    middleName: "middleName",
    lastName: "lastName",
    uniquePersonalIdentification: "uniquePersonalIdentification",
    companyName: "companyName",
    companyId: "companyId",
    employeeNumber: "employeeNumber",
    payrollFrequency: "payrollFrequency",
    payrollFrequencyName: "payrollFrequencyName",
    payrollFrequencyId: "payrollFrequencyId",
    gender: "gender",
    maritalStatus: "maritalStatus",
    primaryEmailAddress: "primaryEmailAddress",
    workPhoneNumber: "workPhoneNumber",
    mobilePhoneNumber: "mobilePhoneNumber",
    address: "address",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    city: "city",
    country: "country",
    countryCode: "countryCode",
    countryId: "countryId",
    foreignCountry: "foreignCountry",
    foreignState: "foreignState",
    state: "state",
    stateId: "stateId",
    zipCode: "zipCode",
    additionalAddressName: "additionalAddressName",
    additionalAddressOne: "additionalAddressOne",
    additionalAddressTwo: "additionalAddressTwo",
    additionalAddressThree: "additionalAddressThree",
    additionalCity: "additionalCity",
    additionalCountry: "additionalCountry",
    additionalCountryCode: "additionalCountryCode",
    additionalCountryId: "additionalCountryId",
    additionalForeignCountry: "additionalForeignCountry",
    additionalForeignState: "additionalForeignState",
    additionalForeignAddressIndicator: "additionalForeignAddressIndicator",
    additionalState: "additionalState",
    additionalStateId: "additionalStateId",
    additionalZipCode: "additionalZipCode",
    birthDate: "birthDate",
    leaveStartDate: "leaveStartDate",
    leaveEndDate: "leaveEndDate",
    hireDate: "hireDate",
    employmentStatus: "employmentStatus",
    employmentStatusId: "employmentStatusId",
    terminationDate: "terminationDate",
    reHireDate: "reHireDate",
    classificationId: "classificationId",
    classificationType: "classificationType",
    classificationCode: "classificationCode",
    classificationName: "classificationName",
    startDate: "startDate",
    endDate: "endDate",
    pendingQDROIndicator: "pendingQDROIndicator",
    ownerShip: "ownerShip",
    masterEmploymentStatusId: "masterEmploymentStatusId",
    familyMemberOfOwnerIndicator: "familyMemberOfOwnerIndicator",
    relationUniquePersonalIdentification:
      "relationUniquePersonalIdentification",
    returnMailIndicator: "returnMailIndicator",
    officerIndicator: "officerIndicator",
    hceIndicator: "hceIndicator",
    hce: "hce",
    HCEIndicatorReason: "HCEIndicatorReason",
    keyEmployeeIndicator: "keyEmployeeIndicator",
    insiderOrRestrictedEmployeeIndicator:
      "insiderOrRestrictedEmployeeIndicator",
    imageURL: "imageURL",
    acceptWarning: "acceptWarning",
    bankAccountName: "bankAccountName",
    routingNumber: "routingNumber",
    bankAccountType: "bankAccountType",
    bankAccountNumber: "bankAccountNumber",
    accountHolderName: "accountHolderName",
  },
  [manageCensusFormNames.ADD_COMPENSATIONS]: {
    payDate: "payDate",
    payPeriodPlanCompensation: "payPeriodPlanCompensation",
    payPeriodGrossCompensation: "payPeriodGrossCompensation",
    annualSalary: "annualSalary",
    eligiblePlanCompensation: "eligiblePlanCompensation",
    eligibleSources: "eligibleSources",
    comments: "comments",
  },
  [manageCensusFormNames.HOURS]: {
    payDate: "payDate",
    hours: "hours",
    comments: "comments",
    startDate: "startDate",
    endDate: "endDate",
  },
  [manageCensusFormNames.BENEFICIARY_DETAILS]: {
    //search: "search",
    beneficiaryName: "beneficiaryName",
    beneficiaryType: "beneficiaryType",
    relationShipType: "relationShipType",
    phoneNumber: "phoneNumber",
    emailId: "emailId",
    dateOfBirth: "dateOfBirth",
    uniquePersonalIdentification: "uniquePersonalIdentification",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    city: "city",
    countryId: "countryId",
    stateId: "stateId",
    zipCode: "zipCode",
    foreignCountry: "foreignCountry",
    foreignState: "foreignState",
    bankAccountName: "bankAccountName",
    routingNumber: "routingNumber",
    bankAccountType: "bankAccountType",
    bankAccountNumber: "bankAccountNumber",
    accountHolderName: "accountHolderName",
  },
  [manageCensusFormNames.CONTRIBUTIONS_FILTER]: {
    startDate: "startDate",
    endDate: "endDate",
    sourcesList: "sourcesList",
  },
  [manageCensusFormNames.ADD_CONTRIBUTIONS]: {
    payDate: "payDate",
    comments: "comments",
  },
  [manageCensusFormNames.CENSUS_HISTORY]: {
    startDate: "startDate",
    endDate: "endDate",
    fields: "fields",
  },
  [manageCensusFormNames.MANUAL_ENROLLMENT]: {
    useDefaultElection: "useDefaultElection",
    useDefaultAllocation: "useDefaultAllocation",
    autoDeferralIncrease: "autoDeferralIncease",
    doesAllSourcesFollowSameElection: "doesAllSourcesFollowSameElection",
  },
  [manageCensusFormNames.CENSUS_VESTING]: {
    vestingOverride: "vestingOverride",
    vestingMultiplier: "vestingMultiplier",
    creditedThisYear: "creditedThisComputationPeriod",
    vestingYOS: "vestingYOS",
    vestingComments: "vestingComments",
    label: "label",
    fromDate: "fromDate",
    toDate: "toDate",
    vestingYOS: "vestingYOS",
    vestingPercentage: "vestingPercentage",
    comments: "comments",
    vestedBalance: "vestedBalance",
    BISType: "BISType",
  },
  [manageCensusFormNames.ROLLOVER_REQUEST]: {
    planName: "planName",
    planType: "planType",
    companyName: "companyName",
    trusteeOrCustodianName: "trusteeOrCustodianName",
    custodianBankName: "custodianBankName",
    custodianAccountNumber: "custodianAccountNumber",
    rolloverAmount: "rolloverAmount",
    bankaccountName: "bankaccountName",
    rothFirstContributionDate: "rothFirstContributionDate",
    chequeNumber: "chequeNumber",
    paymentMode: "paymentMode",
    financialInstitutionName: "financialInstitutionName",
    routingNumber: "routingNumber",
    accountHolderName: "accountHolderName",
    accountType: "accountType",
    accountNumber: "accountNumber",
    contribution: "contribution",
    earnings: "earnings",
    checkLeaf: "checkLeaf",
    spousalConsentForm: "spousalConsentForm",
  },
};

export const EMPLOYEE_RECORDS_TO_FETCH = 20;
